import { useState } from "react";
import axios from "axios";
import { API_URL } from "../utils/apiConfig";

// ─── Translations ──────────────────────────────────────────────────────────────
const T = {
  pt: {
    lang: "PT",
    badge: "Programa de Parceiros Comerciais · Comissão Recorrente",
    hero_title_1: "Ganhe comissão recorrente",
    hero_title_hl: "indicando o Kaiso System",
    hero_title_2: "para restaurantes",
    hero_sub: "Ajude restaurantes a vender mais, organizar pedidos e automatizar atendimento com inteligência artificial.",
    hero_cta: "Quero ser parceiro →",
    hero_note: "Sem vínculo empregatício · Representante independente · 100% comissão",
    how_title: "Como funciona",
    steps: [
      { title: "Cadastre-se", desc: "Preencha o formulário com seus dados" },
      { title: "Receba seu link", desc: "Após aprovação, receba seu link exclusivo de parceiro" },
      { title: "Indique restaurantes", desc: "Compartilhe com donos de restaurantes do seu contato" },
      { title: "Ganhe comissão", desc: "Receba comissão recorrente por cada cliente ativo e pagante" },
    ],
    who_title: "Quem pode participar",
    who_sub: "Qualquer pessoa com rede de contatos pode ser parceira",
    who: ["Influencers", "Vendedores", "Consultores", "Agências de Marketing", "Pessoas com contato com donos de restaurantes", "Criadores de Conteúdo"],
    what_title: "O que você vai vender",
    what_sub: "Uma plataforma completa para restaurantes modernos",
    features: [
      { icon: "🍽️", title: "Menu Digital", desc: "QR code, pedidos online e cardápio com IA" },
      { icon: "💬", title: "WhatsApp com IA", desc: "Atendimento automático 24h com inteligência artificial" },
      { icon: "📱", title: "KDS / Cozinha", desc: "Monitor de pedidos em tempo real para cozinha" },
      { icon: "💳", title: "Caixa / POS", desc: "Sistema de ponto de venda moderno e rápido" },
      { icon: "📅", title: "Reservas", desc: "Gestão de mesas e reservas online" },
      { icon: "📣", title: "Marketing Automático", desc: "Campanhas por WhatsApp e recuperação de clientes" },
      { icon: "📊", title: "Relatórios Financeiros", desc: "Dashboard completo de vendas e performance" },
      { icon: "🤖", title: "Pedidos Online", desc: "Loja digital integrada com pagamentos automáticos" },
    ],
    form_title: "Cadastre-se como parceiro",
    form_sub: "Preencha os dados abaixo. Nossa equipe vai analisar seu perfil.",
    sect_personal: "Dados Pessoais",
    sect_profile: "Perfil Profissional",
    sect_payment: "Dados de Recebimento",
    f_name: "Nome completo *", f_name_ph: "Seu nome completo",
    f_wa: "WhatsApp *", f_wa_ph: "+351 912 345 678",
    f_email: "Email *", f_email_ph: "seu@email.com",
    f_country: "País *", f_country_ph: "Portugal, Brasil, Espanha...",
    f_city: "Cidade *", f_city_ph: "Lisboa, São Paulo...",
    f_lang: "Idioma principal",
    f_social: "Instagram / TikTok / LinkedIn (opcional)", f_social_ph: "@seu_perfil ou link",
    f_type: "Tipo de parceiro *",
    f_sold: "Você já vendeu software, serviços ou produtos digitais? *",
    f_contacts: "Você tem contato direto com donos de restaurantes? *",
    f_estimate: "Quantos restaurantes acredita que consegue indicar por mês? *",
    f_motivation: "Por que quer ser parceiro do Kaiso System? *",
    f_motivation_ph: "Conte um pouco sobre você e por que quer indicar o Kaiso System...",
    f_payment: "Método preferido de recebimento *",
    f_payment_details: "Dados de recebimento (IBAN, endereço Wise, etc.) — opcional",
    f_payment_details_ph: "Pode preencher depois da aprovação",
    f_terms: "Declaro que entendo que atuarei como parceiro independente, sem salário fixo e sem vínculo empregatício, recebendo comissão apenas por resultados confirmados.",
    yes: "Sim", no: "Não",
    submit: "Enviar candidatura →", submitting: "Enviando...",
    success_title: "Cadastro recebido com sucesso!",
    success_body: "Nossa equipe vai analisar seu perfil. Se aprovado, você receberá seu link exclusivo de parceiro por email e WhatsApp.",
    footer: "Parceiros Comerciais",
    partner_types: [
      { value: "influencer", label: "Influencer / Criador de Conteúdo" },
      { value: "seller", label: "Vendedor / Comercial" },
      { value: "agency", label: "Agência de Marketing" },
      { value: "consultant", label: "Consultor" },
      { value: "other", label: "Outro" },
    ],
    err_name: "Nome completo obrigatório",
    err_wa: "WhatsApp obrigatório",
    err_email: "Email inválido",
    err_country: "País obrigatório",
    err_city: "Cidade obrigatória",
    err_type: "Selecione o tipo de parceiro",
    err_sold: "Responda se já vendeu software/serviços digitais",
    err_contacts: "Responda se tem contato com donos de restaurantes",
    err_estimate: "Selecione a estimativa de indicações",
    err_motivation: "Por favor, escreva sua motivação",
    err_payment: "Selecione o método de recebimento",
    err_terms: "Você precisa aceitar os termos para continuar",
    err_generic: "Erro ao enviar. Tente novamente.",
  },
  es: {
    lang: "ES",
    badge: "Programa de Socios Comerciales · Comisión Recurrente",
    hero_title_1: "Gana comisión recurrente",
    hero_title_hl: "recomendando Kaiso System",
    hero_title_2: "a restaurantes",
    hero_sub: "Ayuda a restaurantes a vender más, organizar pedidos y automatizar la atención con inteligencia artificial.",
    hero_cta: "Quiero ser socio →",
    hero_note: "Sin relación laboral · Representante independiente · 100% comisión",
    how_title: "Cómo funciona",
    steps: [
      { title: "Regístrate", desc: "Completa el formulario con tus datos" },
      { title: "Recibe tu enlace", desc: "Tras la aprobación, recibes tu enlace exclusivo de socio" },
      { title: "Recomienda restaurantes", desc: "Comparte con dueños de restaurantes de tu red" },
      { title: "Gana comisión", desc: "Recibe comisión recurrente por cada cliente activo y pagador" },
    ],
    who_title: "¿Quién puede participar?",
    who_sub: "Cualquier persona con red de contactos puede ser socio",
    who: ["Influencers", "Vendedores", "Consultores", "Agencias de Marketing", "Personas con contactos en restaurantes", "Creadores de Contenido"],
    what_title: "Qué vas a vender",
    what_sub: "Una plataforma completa para restaurantes modernos",
    features: [
      { icon: "🍽️", title: "Menú Digital", desc: "QR code, pedidos online y carta con IA" },
      { icon: "💬", title: "WhatsApp con IA", desc: "Atención automática 24h con inteligencia artificial" },
      { icon: "📱", title: "KDS / Cocina", desc: "Monitor de pedidos en tiempo real para cocina" },
      { icon: "💳", title: "Caja / POS", desc: "Sistema de punto de venta moderno y rápido" },
      { icon: "📅", title: "Reservas", desc: "Gestión de mesas y reservas online" },
      { icon: "📣", title: "Marketing Automático", desc: "Campañas por WhatsApp y recuperación de clientes" },
      { icon: "📊", title: "Informes Financieros", desc: "Dashboard completo de ventas y rendimiento" },
      { icon: "🤖", title: "Pedidos Online", desc: "Tienda digital integrada con pagos automáticos" },
    ],
    form_title: "Regístrate como socio",
    form_sub: "Completa los datos. Nuestro equipo analizará tu perfil.",
    sect_personal: "Datos Personales",
    sect_profile: "Perfil Profesional",
    sect_payment: "Datos de Cobro",
    f_name: "Nombre completo *", f_name_ph: "Tu nombre completo",
    f_wa: "WhatsApp *", f_wa_ph: "+34 612 345 678",
    f_email: "Email *", f_email_ph: "tu@email.com",
    f_country: "País *", f_country_ph: "España, México, Argentina...",
    f_city: "Ciudad *", f_city_ph: "Madrid, Ciudad de México...",
    f_lang: "Idioma principal",
    f_social: "Instagram / TikTok / LinkedIn (opcional)", f_social_ph: "@tu_perfil o enlace",
    f_type: "Tipo de socio *",
    f_sold: "¿Ya has vendido software, servicios o productos digitales? *",
    f_contacts: "¿Tienes contacto directo con dueños de restaurantes? *",
    f_estimate: "¿Cuántos restaurantes crees que puedes recomendar por mes? *",
    f_motivation: "¿Por qué quieres ser socio de Kaiso System? *",
    f_motivation_ph: "Cuéntanos un poco sobre ti y por qué quieres recomendar Kaiso System...",
    f_payment: "Método de cobro preferido *",
    f_payment_details: "Datos de cobro (IBAN, dirección Wise, etc.) — opcional",
    f_payment_details_ph: "Puedes rellenarlo después de la aprobación",
    f_terms: "Declaro que entiendo que actuaré como socio independiente, sin salario fijo ni relación laboral, recibiendo comisión solo por resultados confirmados.",
    yes: "Sí", no: "No",
    submit: "Enviar candidatura →", submitting: "Enviando...",
    success_title: "¡Solicitud recibida con éxito!",
    success_body: "Nuestro equipo analizará tu perfil. Si eres aprobado, recibirás tu enlace exclusivo de socio por email y WhatsApp.",
    footer: "Socios Comerciales",
    partner_types: [
      { value: "influencer", label: "Influencer / Creador de Contenido" },
      { value: "seller", label: "Vendedor / Comercial" },
      { value: "agency", label: "Agencia de Marketing" },
      { value: "consultant", label: "Consultor" },
      { value: "other", label: "Otro" },
    ],
    err_name: "Nombre completo obligatorio",
    err_wa: "WhatsApp obligatorio",
    err_email: "Email inválido",
    err_country: "País obligatorio",
    err_city: "Ciudad obligatoria",
    err_type: "Selecciona el tipo de socio",
    err_sold: "Responde si ya has vendido software/servicios digitales",
    err_contacts: "Responde si tienes contacto con dueños de restaurantes",
    err_estimate: "Selecciona la estimación de recomendaciones",
    err_motivation: "Por favor, escribe tu motivación",
    err_payment: "Selecciona el método de cobro",
    err_terms: "Debes aceptar los términos para continuar",
    err_generic: "Error al enviar. Inténtalo de nuevo.",
  },
  en: {
    lang: "EN",
    badge: "Commercial Partner Program · Recurring Commission",
    hero_title_1: "Earn recurring commissions",
    hero_title_hl: "by referring Kaiso System",
    hero_title_2: "to restaurants",
    hero_sub: "Help restaurants sell more, manage orders and automate customer service with artificial intelligence.",
    hero_cta: "Become a partner →",
    hero_note: "No employment contract · Independent representative · 100% commission",
    how_title: "How it works",
    steps: [
      { title: "Sign up", desc: "Fill in the form with your details" },
      { title: "Get your link", desc: "After approval, receive your exclusive partner link" },
      { title: "Refer restaurants", desc: "Share with restaurant owners in your network" },
      { title: "Earn commission", desc: "Receive recurring commission for every active, paying client" },
    ],
    who_title: "Who can participate",
    who_sub: "Anyone with a network of contacts can be a partner",
    who: ["Influencers", "Sales people", "Consultants", "Marketing agencies", "People with restaurant owner contacts", "Content creators"],
    what_title: "What you'll sell",
    what_sub: "A complete platform for modern restaurants",
    features: [
      { icon: "🍽️", title: "Digital Menu", desc: "QR code, online orders and AI-powered menu" },
      { icon: "💬", title: "WhatsApp AI", desc: "Automated 24h customer service with artificial intelligence" },
      { icon: "📱", title: "KDS / Kitchen", desc: "Real-time order monitor for the kitchen" },
      { icon: "💳", title: "POS / Cashier", desc: "Modern and fast point-of-sale system" },
      { icon: "📅", title: "Reservations", desc: "Table and online booking management" },
      { icon: "📣", title: "Auto Marketing", desc: "WhatsApp campaigns and customer recovery" },
      { icon: "📊", title: "Financial Reports", desc: "Complete sales and performance dashboard" },
      { icon: "🤖", title: "Online Orders", desc: "Digital store integrated with automatic payments" },
    ],
    form_title: "Apply as a partner",
    form_sub: "Fill in the details below. Our team will review your profile.",
    sect_personal: "Personal Details",
    sect_profile: "Professional Profile",
    sect_payment: "Payment Details",
    f_name: "Full name *", f_name_ph: "Your full name",
    f_wa: "WhatsApp *", f_wa_ph: "+44 7911 123456",
    f_email: "Email *", f_email_ph: "you@email.com",
    f_country: "Country *", f_country_ph: "UK, USA, Canada...",
    f_city: "City *", f_city_ph: "London, New York...",
    f_lang: "Main language",
    f_social: "Instagram / TikTok / LinkedIn (optional)", f_social_ph: "@your_profile or link",
    f_type: "Partner type *",
    f_sold: "Have you sold software, services or digital products before? *",
    f_contacts: "Do you have direct contacts with restaurant owners? *",
    f_estimate: "How many restaurants do you think you can refer per month? *",
    f_motivation: "Why do you want to be a Kaiso System partner? *",
    f_motivation_ph: "Tell us a bit about yourself and why you want to recommend Kaiso System...",
    f_payment: "Preferred payment method *",
    f_payment_details: "Payment details (IBAN, Wise address, etc.) — optional",
    f_payment_details_ph: "You can fill this in after approval",
    f_terms: "I declare that I understand I will act as an independent partner, with no fixed salary and no employment contract, receiving commission only for confirmed results.",
    yes: "Yes", no: "No",
    submit: "Submit application →", submitting: "Sending...",
    success_title: "Application received successfully!",
    success_body: "Our team will review your profile. If approved, you'll receive your exclusive partner link by email and WhatsApp.",
    footer: "Commercial Partners",
    partner_types: [
      { value: "influencer", label: "Influencer / Content Creator" },
      { value: "seller", label: "Sales / Commercial" },
      { value: "agency", label: "Marketing Agency" },
      { value: "consultant", label: "Consultant" },
      { value: "other", label: "Other" },
    ],
    err_name: "Full name required",
    err_wa: "WhatsApp required",
    err_email: "Invalid email",
    err_country: "Country required",
    err_city: "City required",
    err_type: "Select partner type",
    err_sold: "Answer whether you've sold software/digital services",
    err_contacts: "Answer whether you have restaurant owner contacts",
    err_estimate: "Select the referral estimate",
    err_motivation: "Please write your motivation",
    err_payment: "Select a payment method",
    err_terms: "You need to accept the terms to continue",
    err_generic: "Error sending. Please try again.",
  },
};

const LANGUAGES = [
  { code: "pt", flag: "🇵🇹", name: "Português" },
  { code: "es", flag: "🇪🇸", name: "Español" },
  { code: "en", flag: "🇬🇧", name: "English" },
];

const PAYMENT_METHODS = ["IBAN", "Wise", "Revolut", "PayPal", "Outro / Other"];
const REFERRAL_ESTIMATES = ["1-3", "4-10", "10+"];
const WHO_ICONS = ["📱", "💼", "🎯", "🏢", "🤝", "🎬"];

const EMPTY_FORM = {
  full_name: "", whatsapp: "", email: "", country: "", city: "",
  language: "Português", social_media: "", partner_type: "",
  has_sold_software: null, has_restaurant_contacts: null,
  monthly_referrals_estimate: "", motivation: "",
  payment_method: "", payment_details: "", agreed_to_terms: false,
};

export default function PartnersApplyPage() {
  const [lang, setLang] = useState("pt");
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const t = T[lang];

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validate = () => {
    if (!form.full_name.trim()) return t.err_name;
    if (!form.whatsapp.trim()) return t.err_wa;
    if (!form.email.trim() || !form.email.includes("@")) return t.err_email;
    if (!form.country.trim()) return t.err_country;
    if (!form.city.trim()) return t.err_city;
    if (!form.partner_type) return t.err_type;
    if (form.has_sold_software === null) return t.err_sold;
    if (form.has_restaurant_contacts === null) return t.err_contacts;
    if (!form.monthly_referrals_estimate) return t.err_estimate;
    if (!form.motivation.trim()) return t.err_motivation;
    if (!form.payment_method) return t.err_payment;
    if (!form.agreed_to_terms) return t.err_terms;
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) { setError(err); return; }
    setError("");
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/affiliate/partner-apply`, {
        ...form,
        has_sold_software: form.has_sold_software === true,
        has_restaurant_contacts: form.has_restaurant_contacts === true,
      });
      setSuccess(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (ex) {
      setError(ex.response?.data?.detail || t.err_generic);
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-emerald-950 flex items-center justify-center p-6">
        <div className="bg-white/5 border border-emerald-500/30 rounded-3xl p-10 max-w-lg w-full text-center backdrop-blur-sm">
          <div className="w-20 h-20 rounded-full bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center mx-auto mb-6">
            <span className="text-4xl">✅</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-3">{t.success_title}</h2>
          <p className="text-gray-300 leading-relaxed">{t.success_body}</p>
          <div className="mt-8 text-sm text-gray-500">Kaiso System · {t.footer}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-emerald-950 text-white">
      {/* NAV */}
      <nav className="flex items-center justify-between px-6 py-4 max-w-6xl mx-auto">
        <div className="flex items-center gap-2">
          <span className="text-2xl font-black tracking-tight text-white">Kaiso</span>
          <span className="text-emerald-400 font-black text-2xl">System</span>
        </div>
        <div className="flex items-center gap-3">
          {/* Language switcher */}
          <div className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-full p-1">
            {LANGUAGES.map((l) => (
              <button
                key={l.code}
                onClick={() => setLang(l.code)}
                title={l.name}
                className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${lang === l.code ? "bg-emerald-500 text-white shadow-sm" : "text-gray-400 hover:text-white"}`}
              >
                {l.flag} {l.code.toUpperCase()}
              </button>
            ))}
          </div>
          <a href="#formulario" className="hidden sm:block text-sm text-emerald-400 hover:text-emerald-300 font-semibold border border-emerald-500/40 rounded-full px-4 py-1.5 transition-colors">
            {t.hero_cta}
          </a>
        </div>
      </nav>

      {/* HERO */}
      <section className="max-w-5xl mx-auto px-6 py-20 text-center">
        <div className="inline-block bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 text-emerald-400 text-sm font-semibold mb-8">
          {t.badge}
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight mb-6">
          {t.hero_title_1}{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-300">
            {t.hero_title_hl}
          </span>{" "}
          {t.hero_title_2}
        </h1>
        <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed">
          {t.hero_sub}
        </p>
        <a
          href="#formulario"
          className="inline-block bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-400 hover:to-teal-400 text-white font-bold text-lg px-10 py-4 rounded-2xl shadow-lg shadow-emerald-900/40 transition-all transform hover:scale-105"
        >
          {t.hero_cta}
        </a>
        <p className="text-sm text-gray-500 mt-4">{t.hero_note}</p>
      </section>

      {/* HOW IT WORKS */}
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center mb-12">{t.how_title}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.steps.map((s, i) => (
            <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-emerald-500/40 transition-colors">
              <div className="w-10 h-10 rounded-full bg-emerald-500 text-white font-black text-lg flex items-center justify-center mb-4">
                {i + 1}
              </div>
              <h3 className="font-bold text-white mb-2">{s.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* WHO CAN */}
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center mb-4">{t.who_title}</h2>
        <p className="text-center text-gray-400 mb-12">{t.who_sub}</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {t.who.map((w, i) => (
            <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-5 flex items-center gap-3 hover:border-emerald-500/40 transition-colors">
              <span className="text-2xl">{WHO_ICONS[i] || "✨"}</span>
              <span className="text-sm font-semibold text-gray-200">{w}</span>
            </div>
          ))}
        </div>
      </section>

      {/* WHAT YOU'LL SELL */}
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center mb-4">{t.what_title}</h2>
        <p className="text-center text-gray-400 mb-12">{t.what_sub}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.features.map((f, i) => (
            <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:border-emerald-500/30 transition-colors">
              <span className="text-3xl mb-3 block">{f.icon}</span>
              <h3 className="font-bold text-white text-sm mb-1">{f.title}</h3>
              <p className="text-xs text-gray-400 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FORM */}
      <section id="formulario" className="max-w-3xl mx-auto px-6 py-16">
        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 sm:p-10 backdrop-blur-sm">
          <h2 className="text-3xl font-bold mb-2">{t.form_title}</h2>
          <p className="text-gray-400 mb-8 text-sm">{t.form_sub}</p>

          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Personal */}
            <div>
              <SectionLabel>{t.sect_personal}</SectionLabel>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Field label={t.f_name} value={form.full_name} onChange={(v) => set("full_name", v)} placeholder={t.f_name_ph} />
                <Field label={t.f_wa} value={form.whatsapp} onChange={(v) => set("whatsapp", v)} placeholder={t.f_wa_ph} />
                <Field label={t.f_email} type="email" value={form.email} onChange={(v) => set("email", v)} placeholder={t.f_email_ph} />
                <Field label={t.f_country} value={form.country} onChange={(v) => set("country", v)} placeholder={t.f_country_ph} />
                <Field label={t.f_city} value={form.city} onChange={(v) => set("city", v)} placeholder={t.f_city_ph} />
                <div>
                  <label className="block text-xs font-semibold text-gray-400 mb-1.5">{t.f_lang}</label>
                  <select
                    value={form.language}
                    onChange={(e) => set("language", e.target.value)}
                    className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-emerald-500"
                  >
                    {["Português", "Español", "English", "العربية", "Outro / Other"].map((l) => (
                      <option key={l} value={l} className="bg-gray-900">{l}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Profile */}
            <div>
              <SectionLabel>{t.sect_profile}</SectionLabel>
              <div className="space-y-5">
                <Field label={t.f_social} value={form.social_media} onChange={(v) => set("social_media", v)} placeholder={t.f_social_ph} />

                <div>
                  <label className="block text-xs font-semibold text-gray-400 mb-2">{t.f_type}</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {t.partner_types.map((pt) => (
                      <label key={pt.value} className={`flex items-center gap-3 p-3 rounded-xl border cursor-pointer transition-colors ${form.partner_type === pt.value ? "border-emerald-500 bg-emerald-500/10" : "border-white/10 hover:border-white/25"}`}>
                        <input type="radio" name="partner_type" value={pt.value} checked={form.partner_type === pt.value} onChange={() => set("partner_type", pt.value)} className="accent-emerald-500" />
                        <span className="text-sm text-gray-200">{pt.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <YesNo label={t.f_sold} value={form.has_sold_software} onChange={(v) => set("has_sold_software", v)} yes={t.yes} no={t.no} />
                <YesNo label={t.f_contacts} value={form.has_restaurant_contacts} onChange={(v) => set("has_restaurant_contacts", v)} yes={t.yes} no={t.no} />

                <div>
                  <label className="block text-xs font-semibold text-gray-400 mb-2">{t.f_estimate}</label>
                  <div className="flex gap-3">
                    {REFERRAL_ESTIMATES.map((e) => (
                      <label key={e} className={`flex-1 flex items-center justify-center p-3 rounded-xl border cursor-pointer transition-colors text-sm font-bold ${form.monthly_referrals_estimate === e ? "border-emerald-500 bg-emerald-500/10 text-emerald-400" : "border-white/10 text-gray-300 hover:border-white/25"}`}>
                        <input type="radio" name="monthly" value={e} checked={form.monthly_referrals_estimate === e} onChange={() => set("monthly_referrals_estimate", e)} className="hidden" />
                        {e}
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-400 mb-1.5">{t.f_motivation}</label>
                  <textarea
                    value={form.motivation}
                    onChange={(e) => set("motivation", e.target.value)}
                    rows={4}
                    placeholder={t.f_motivation_ph}
                    className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-emerald-500 resize-none placeholder-gray-500"
                  />
                </div>
              </div>
            </div>

            {/* Payment */}
            <div>
              <SectionLabel>{t.sect_payment}</SectionLabel>
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-400 mb-2">{t.f_payment}</label>
                  <div className="flex flex-wrap gap-2">
                    {PAYMENT_METHODS.map((m) => (
                      <label key={m} className={`px-4 py-2 rounded-full border cursor-pointer text-sm font-semibold transition-colors ${form.payment_method === m ? "border-emerald-500 bg-emerald-500/10 text-emerald-400" : "border-white/10 text-gray-300 hover:border-white/25"}`}>
                        <input type="radio" name="payment_method" value={m} checked={form.payment_method === m} onChange={() => set("payment_method", m)} className="hidden" />
                        {m}
                      </label>
                    ))}
                  </div>
                </div>
                <Field label={t.f_payment_details} value={form.payment_details} onChange={(v) => set("payment_details", v)} placeholder={t.f_payment_details_ph} />
              </div>
            </div>

            {/* Terms */}
            <label className="flex items-start gap-3 cursor-pointer group">
              <div
                className={`mt-0.5 w-5 h-5 rounded border flex-shrink-0 flex items-center justify-center transition-colors ${form.agreed_to_terms ? "bg-emerald-500 border-emerald-500" : "border-white/30 group-hover:border-white/50"}`}
                onClick={() => set("agreed_to_terms", !form.agreed_to_terms)}
              >
                {form.agreed_to_terms && (
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              <input type="checkbox" checked={form.agreed_to_terms} onChange={(e) => set("agreed_to_terms", e.target.checked)} className="hidden" />
              <span className="text-sm text-gray-300 leading-relaxed">{t.f_terms}</span>
            </label>

            {error && (
              <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4 text-red-400 text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-400 hover:to-teal-400 disabled:opacity-60 disabled:cursor-not-allowed text-white font-bold text-lg py-4 rounded-2xl shadow-lg shadow-emerald-900/40 transition-all transform hover:scale-[1.01]"
            >
              {submitting ? t.submitting : t.submit}
            </button>
          </form>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="text-center py-10 text-gray-600 text-sm border-t border-white/5">
        © {new Date().getFullYear()} Kaiso System · {t.footer}
      </footer>
    </div>
  );
}

function SectionLabel({ children }) {
  return (
    <h3 className="text-xs font-bold text-emerald-400 uppercase tracking-widest mb-4">{children}</h3>
  );
}

function Field({ label, value, onChange, placeholder, type = "text" }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-gray-400 mb-1.5">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-emerald-500 placeholder-gray-500"
      />
    </div>
  );
}

function YesNo({ label, value, onChange, yes, no }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-gray-400 mb-2">{label}</label>
      <div className="flex gap-3">
        {[{ v: true, l: yes }, { v: false, l: no }].map(({ v, l }) => (
          <label key={l} className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-xl border cursor-pointer transition-colors text-sm font-semibold ${value === v ? "border-emerald-500 bg-emerald-500/10 text-emerald-400" : "border-white/10 text-gray-300 hover:border-white/25"}`}>
            <input type="radio" checked={value === v} onChange={() => onChange(v)} className="hidden" />
            {l}
          </label>
        ))}
      </div>
    </div>
  );
}
